import {Profile} from "./profile";
import type {TerritoryDef} from "~/types/apps";
import {Group} from "~/lib/models/group";
import {isDefined} from "~/lib/helpers/guards";

class User {

  public id: number = null;
  public uuid: string = null;
  public email: string = null;
  public createdAt: Date = null;
  public lastConnection: Date = null;
  public active: boolean = null;
  public confirmationStatus: number = null;
  public profile: Profile = null;
  public department: string = null;
  public roles: number[] = [];
  public roleLabel:string = null;

  public groups: number[] = [];
  public territory: TerritoryDef = null;
  public cguSigned: boolean = null;
  public client: string;

  public static fromPayload(pl: Partial<User>): User {
    !pl && (pl = {});
    const o = new User();
    Object.assign(o, pl);
    o.profile = Profile.fromPayload(pl.profile);
    return o;
  }

  public static create(clientUUID:string){
    let user = new User();
    user.profile = new Profile();
    user.client = clientUUID;
    return user;
  }

  get role0(){
    return this.roles[0] || null;
  }

  get hasPrivateRole(){
    return !isDefined(this.role0) && isDefined(this.roleLabel);
  }

  set role0(role) {
    if (!role) {
      this.roles = [];
    } else {
      this.roles = [role];
    }
  }

  updateGroupList(groups:Group[]){
    this.groups = groups.map(grp => grp.id);
  }

  removeGroup(group:Group){
    if( this.groups.indexOf( group.id ) !== -1 ){
      this.groups = this.groups.filter(grID => grID !== group.id);
    }
  }

  toJSON(){

    let payload = {
      ...this,
      groupsIDS: this.groups,
      roleId: this.role0,
      client: this.client
    };

    delete payload.groups;
    delete payload.roles;

    return payload;
  }

}

export { User }
